import React from 'react'
import { SliderOnboarding } from '@/components/SliderOnboarding'
import { QuestionProps } from '../types'

export const WorkConfidence = (props: QuestionProps) => {
  const { form, disabled } = props

  function onValueChange(value: number | number[]) {
    if (Array.isArray(value)) value = value[0]

    form.setFieldValue('confidence_at_work', value)
  }

  return (
    <SliderOnboarding
      {...form.register('confidence_at_work')}
      onValueChange={onValueChange}
      disabled={disabled}
      label=""
    />
  )
}
